import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';

import * as S from './CategoryComponent.style';
import CategoryTitleItem from './CategoryTitleItem';
import CategoryDetailBox from './CategoryDetailBox';
import { RootStoreContext } from '../../../App';
import useTagClickHandler from '../../../hooks/useTagClickHandler';
import { premiumTags, seoulTags } from '../../../data/categoryTagId';

const CATEGORY_TITLES = [
	{ name: '언어', id: 1 },
	{ name: '영어', id: 2 },
	{ name: '미술', id: 3 },
	{ name: '음악', id: 4 },
	{ name: '과학', id: 5 },
	{ name: '안전', id: 6 },
	{ name: '역사', id: 7 },
	{ name: '리쿠 행사', id: 8 },
];

const SENIOR_CATEGORY_TITLES = [
	{ name: '치매예방 인지', id: 4 },
	{ name: '건강지킴 신체', id: 1 },
	{ name: '마음힐링 정서', id: 3 },
	{ name: '지식쌓기 교양', id: 2 },
];
// const SENIOR_CATEGORY_TITLES = [
// 	{ name: '치매예방 인지', id: 1 },
// 	{ name: '인지', id: 2 },
// ];

const CategoryComponent = observer(() => {
	const { authStore, likuStore } = useContext(RootStoreContext);
	const tagClickHandler = useTagClickHandler('unique');
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const isSeoul = authStore.isSeoul;
	const isSenior = authStore.isSenior;
	const isKid = authStore.isKid;

	const [selectedItemId, setSelectedItemId] = useState(null);
	const [hoveredItemID, setHoveredItemID] = useState(null);
	const [showDetailBox, setShowDetailBox] = useState(false);
	const [isCategoryHovered, setIsCategoryHovered] = useState(false);
	const [isMouseOnBlackBackground, setIsMouseOnBlackBackground] =
		useState(false);

	const curCategory = searchParams.get('category');
	const handleItemClick = (itemId) => {
		setSelectedItemId((prev) => (prev === itemId ? null : itemId));
	};

	const handleItemHover = (itemId) => {
		setHoveredItemID(itemId);
	};

	const handlePremiumItemClick = (tag) => {
		const { id } = tag;

		if (id === 55) {
			if (!likuStore.thisLiku) return alert('로봇을 연결해주세요');
			return window.open('http://aien.torooc.com');
		}

		const roleCheckMap = {
			7: '융합과학',
			8: '생각톡톡',
		};

		if (roleCheckMap[id] && !authStore.hasRoleById(id)) {
			alert(`${roleCheckMap[id]} 서비스 구매 회원만 이용 가능합니다.`);
			return;
		}

		tagClickHandler(tag, 'search');
	};

	const renderMainCategory = () => {
		if (isSeoul) return null;

		const categories = isSenior ? SENIOR_CATEGORY_TITLES : CATEGORY_TITLES;

		return categories.map((item) => (
			<CategoryTitleItem
				key={item.id}
				item={item}
				selected={item.name === curCategory}
				onClick={() => handleItemClick(item.id)}
				onHover={() => {
					handleItemHover(item.id);
					setShowDetailBox(true);
					setIsMouseOnBlackBackground(false);
				}}
				isHovered={hoveredItemID === item.id}
				titleType='main'
				isMouseOnBlackBackground={isMouseOnBlackBackground}
			/>
		));
	};

	const renderSubCategory = () => {
		const tagList = isKid ? premiumTags : isSeoul ? seoulTags : [];

		return tagList.map((item) => (
			<CategoryTitleItem
				key={item.id}
				item={item}
				isPremium
				selected={selectedItemId}
				onClick={() => handlePremiumItemClick(item)}
				onHover={() => {
					handleItemHover(item.id);
					setShowDetailBox(false);
				}}
				isHovered={hoveredItemID === item.id}
				titleType='sub'
			/>
		));
	};

	return (
		<S.Container
			onMouseEnter={() => setIsCategoryHovered(true)}
			onMouseLeave={() => {
				setIsCategoryHovered(false);
				setHoveredItemID(null);
			}}>
			<S.CategoryBox>
				{renderMainCategory()}
				{renderSubCategory()}
				{/* <CategoryTitleItem
					item={{ name: '내콘텐츠', id: 'myContent' }}
					onClick={() => handleItemClick('myContent')}
					onHover={() => {
						handleItemHover('myContent');
					}}
				/> */}
			</S.CategoryBox>

			{isCategoryHovered && showDetailBox && hoveredItemID !== null && (
				<CategoryDetailBox
					isHovered={isCategoryHovered}
					setIsHovered={setIsCategoryHovered}
					categoryID={hoveredItemID}
					setIsMouseOnBlackBackground={setIsMouseOnBlackBackground}
					setMainCategory={handleItemClick}
				/>
			)}
		</S.Container>
	);
});

export default CategoryComponent;
